import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";
import { DEFAULT_ROADWORK_ICON } from "src/app/config/app.config";
import { RoutePath } from "src/app/config/routing.config";
import { DigitalEquipment, User } from "src/app/models";
import { AuthService } from "src/app/services/auth.service";
import { DigitalRoadworkService } from "src/app/services/digital-roadwork.service";
import { environment } from "src/environments/environment.defaults";

/**
 * Header with ASF logo and a navigation which is shown when the user is logged in.
 */
@Component({
	selector: "dr-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
	public availableRoutePaths = RoutePath;
	public showListBtn = false;
	public showMapBtn = false;
	public isUserLoggedIn = false;
	public user?: User;

	public readonly version = environment.version;
	public readonly asfSvgCacheBaseUrl = environment.asfSvgCacheUrl;
	public readonly roadworkIcon = DEFAULT_ROADWORK_ICON;
	public readonly roadworkIconSize = 40;
	public currentAssetId: string | null = null;
	public currentAssetIdNumber: number | null = null;
	public allDigitalEquipments: Map<string, DigitalEquipment> = new Map<string, DigitalEquipment>();

	private readonly subscriptions: Subscription[] = [];

	constructor(
		private readonly authService: AuthService,
		private readonly digitalRoadworkService: DigitalRoadworkService,
		private readonly router: Router,
	) {}

	public ngOnInit(): void {
		this.subscriptions.push(
			this.router.events
				.pipe(
					filter((event): event is NavigationEnd => event instanceof NavigationEnd),
					map((event) => event.urlAfterRedirects.split("/")[1].split("?")[0] as RoutePath),
				)
				.subscribe((firstUrlSegment) => {
					this.showListBtn = firstUrlSegment === RoutePath.Map || firstUrlSegment === RoutePath.Roadwork;
					this.showMapBtn = firstUrlSegment === RoutePath.List || firstUrlSegment === RoutePath.Roadwork;
				}),
			this.authService.User$.subscribe((user) => (this.user = user)),
			this.authService.IsUserLoggedIn$.subscribe((isUserLoggedIn) => (this.isUserLoggedIn = isUserLoggedIn)),
			this.digitalRoadworkService.idOfCurrentDigitalEquipmentFromUser
				.pipe(startWith(null))
				.subscribe((assetId) => {


					this.currentAssetId = assetId;
					if (this.currentAssetId != null) {
						this.currentAssetIdNumber = parseInt(this.currentAssetId.replace("-", ""),10);
					}
					
					
				
				}),
		);
		this.digitalRoadworkService.currentAllDigitalEquipments
			.pipe()
			.subscribe((digitalEquipments) => (this.allDigitalEquipments = digitalEquipments));
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	public logout(): void {
		this.authService.logout();
	}

	public handleDigitalEquipmentChanged(assetId: string) {
		this.digitalRoadworkService.setDigitalEquipmentFromUser(assetId);
	}
}
